import { OpenInNew } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { useUser } from "../../../api/useAuth";
import { usePsySessionNote } from "../../../api/usePsySessionNote";
import { FOLLOWUP_SERVICE, REPORTS_SERVICE } from "../../../utils/constants";

type SessionNoteButtonProps = {
	session: any;
	hasNote?: boolean;
	category: "psychology" | "client_owner";
	treatmentTab: "psychology" | "notes";
};

const getNoteTitle = (serviceId: number) => {
	if (serviceId === FOLLOWUP_SERVICE) return "follow_up_sessions";
	if (serviceId === REPORTS_SERVICE) return "report_meeting_mid";
	return "";
};

export const SessionNoteButton = ({ session, hasNote, category, treatmentTab }: SessionNoteButtonProps) => {
	const { data: user } = useUser();
	const technicianUserId = session?.technician?.user_id?.id ?? session?.technician?.user_id;
	const isSessionTechnician = !!user?.id && technicianUserId === user?.id;
	const { data: existingNoteId } = usePsySessionNote(session?.id, category, hasNote === undefined && isSessionTechnician);

	const treatmentId = session?.treatment?.id;
	if (!treatmentId) return null;

	if (!isSessionTechnician) return null;
	if (hasNote) return null;

	const buildUrl = () => {
		if (existingNoteId) return `/treatments/${treatmentId}/${treatmentTab}?[noteId]=${existingNoteId}`;

		const baseUrl = `/treatments/${treatmentId}/${treatmentTab}?[mode]=create&[sessionId]=${session.id}`;
		if (category === "psychology") return baseUrl;

		const noteTitle = getNoteTitle(session?.service?.id);
		return `${baseUrl}&[category]=${category}&[title]=${noteTitle}`;
	};

	return (
		<Box sx={{ display: "flex", alignItems: "center" }}>
			<Button
				onClick={() => window.open(buildUrl(), "_blank")}
				variant="contained"
				disableElevation
				size="large"
				color="secondary"
				endIcon={<OpenInNew />}
			>
				<Typography variant="body1">{existingNoteId ? "Ver Nota" : "Criar Nota"}</Typography>
			</Button>
		</Box>
	);
};
